import { Fragment } from 'react';
import { Header, Tab } from 'semantic-ui-react';
import TasksTable from '../../../components/admin/task/tasksTable';
import { TASK_STATUS, TASK_STATUSES_CONSIDERED_ACTIVE } from '../../../constnats/task';
import { getPaneCfg } from '../../../utils/general';

function Tasks() {
    const panes = [
        getPaneCfg('Active', <TasksTable filters={{statuses: TASK_STATUSES_CONSIDERED_ACTIVE}} taskCreationEnabled/>),
        getPaneCfg('Completed', <TasksTable filters={{statuses: [TASK_STATUS.COMPLETED]}} />),
    ];
    return (
        <Fragment>
            <Header as="h2" textAlign="center">
                Tasks
            </Header>
            <Tab panes={panes} />
        </Fragment>
    );
}

export default Tasks;
